import { LANGUAGES } from 'i18n';
import { IConfirmedBet } from 'core/widgets/Bet/types';
import { BaseService } from './BaseService';

export interface ICreatePendingBetRequestData {
  bets: IConfirmedBet[];
  timeStamp: number;
}

export interface ICreatePendingBetResponseData {
  bets: IConfirmedBet[];
  timeStamp: number;
  total: number;
}

export interface IStreamLoadRequestData {
  sessionId: string;
  time: number;
  load: boolean;
}

class RestAPIService extends BaseService {
  public async createPendingBet(data: ICreatePendingBetRequestData) {
    const result = await this.post<ICreatePendingBetResponseData | null>('bets/create', data, {
      'Content-Type': 'application/json; charset=utf-8',
    });

    if (result.status === 201) {
      return result.data;
    }

    return null;
  }

  public async sendStreamLoadData(data: IStreamLoadRequestData) {
    return await this.post('loading', data, {
      'Content-Type': 'application/json; charset=utf-8',
    });
  }

  public async getGameRules(locale: LANGUAGES) {
    const route = `game-rules/${locale}`;

    return this.getAPI(route);
  }

  public async getHistory() {
    const route = `bets/history`;

    return this.getAPI(route);
  }
}

export const RestService = new RestAPIService();
